import type { ComponentType } from 'react'
import {
  UserOutlined,
  EnvironmentOutlined,
  AlertOutlined,
  ShareAltOutlined,
  TeamOutlined,
  IdcardOutlined,
  HistoryOutlined,
  StarOutlined,
  InfoCircleOutlined,
  FileTextOutlined,
} from '@ant-design/icons'
import { CATEGORIES } from '@sportninja/common/features/profile/player'
import type { ScrollSpyItem } from 'src/components/ScrollSpyLayout'

// Per-category icons for the Edit Player sidebar. Falls back to a person icon
// for any category not mapped here (a dev-only warning fires in that case).
const CATEGORY_ICONS: Record<string, ComponentType> = {
  personal: UserOutlined,
  address: EnvironmentOutlined,
  emergencyContact: AlertOutlined,
  family: TeamOutlined,
  // Same icon as the Player Details section it mirrors.
  experience: HistoryOutlined,
  preferences: StarOutlined,
  additional: InfoCircleOutlined,
  notes: FileTextOutlined,
  socialProfiles: ShareAltOutlined,
  membership: IdcardOutlined,
}

export const PLAYER_SETUP_ITEMS: ScrollSpyItem[] = CATEGORIES.map((cat) => {
  if (process.env.NODE_ENV !== 'production' && !CATEGORY_ICONS[cat.key]) {
    console.warn(
      `playerSetupItems: no icon mapped for category "${cat.key}" — using fallback. ` +
        'Add it to CATEGORY_ICONS.'
    )
  }
  return {
    key: cat.key,
    label: cat.label,
    icon: CATEGORY_ICONS[cat.key] ?? UserOutlined,
  }
})
